import { GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { getCanonicalAndLanguageAlternates } from "@/utils/seo";
import { Page } from "@/components/Layout";
import { getChainInfo } from "@/utils";

const LiquidityView = dynamic(() => import("@/views").then((module) => module.LiquidityView), { ssr: false });

const LiquidityPage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const currentChainInfo = getChainInfo();

  const title = "Liquidity Rewards";
  //@todo-lp
  const description = "";
  const { canonical, languageAlternates } = getCanonicalAndLanguageAlternates(
    `/liquidity/`,
    router,
    currentChainInfo.appUrl
  );

  return (
    <Page title={title}>
      <NextSeo
        noindex
        nofollow
        title={title}
        description={description}
        openGraph={{
          url: canonical,
          title: t("{{pageTitle}} | YOLO Games", { pageTitle: title }),
          description: description,
          images: [
            {
              // @todo-lp
              url: ``,
              alt: "",
              width: 1600,
              height: 840,
              type: "image/png",
            },
          ],
        }}
        canonical={canonical}
        languageAlternates={languageAlternates}
      />
      <LiquidityView />
    </Page>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale = "en" }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["liq", "common"])),
    },
  };
};

export default LiquidityPage;
